<template>
  <a-result status="500" title="服务器错误" sub-title="请联络系统管理员或稍后再试">
    <template #extra>
      <a-space>
        <a-button @click="goHomeMeasurement">
          度量平台主页
        </a-button>
        <a-button @click="goHomeDemand">
          需求平台主页
        </a-button>
        <a-button @click="goToAiAgent">
          AI Agent
        </a-button>
        <a-button type="primary" @click="reloadPage">
          重试
        </a-button>
        <a-button class="logout-button" @click="logOut">
          登出
        </a-button>
      </a-space>
    </template>
  </a-result>
</template>

<script>
import Cookies from 'js-cookie';
export default {
  name: 'OpNetworkError',
  methods: {
    goHomeDemand() {
      this.$router.push('/demand-platform');
    },
    goHomeMeasurement() {
      this.$router.push('/measurement-platform');
    },
    reloadPage() {
      this.$router.go(-1);
    },
    goToAiAgent() {
      window.location.href = '//aiagent.chaobangai.com';
    },
    logOut() {
      Cookies.remove('accessToken', { path: '/' });
      Cookies.remove('refreshToken', { path: '/' });
      localStorage.removeItem('token_timestamp');
      window.location.href = '/login';
    }
  }
};
</script>

<style scoped>
.logout-button {
  border-color: #f44336;
}

.logout-button:hover {
  background-color: #d32f2f;
  border-color: #d32f2f;
  color: white;
}
</style>